import { render } from "./ServiceProvidersTab.vue?vue&type=template&id=e4c2e130&scoped=true"
import script from "./ServiceProvidersTab.vue?vue&type=script&lang=js"
export * from "./ServiceProvidersTab.vue?vue&type=script&lang=js"

import "./ServiceProvidersTab.vue?vue&type=style&index=0&id=e4c2e130&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4c2e130"]])

export default __exports__